// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__vy9kvL2Q","warning":"SignUpIncorrectBirthStep_warning__pDODA2eE","back":"SignUpIncorrectBirthStep_back__arGe4KpU"};